export const TELEMETRY_SCHEMA_VERSION = '1.2';

export const EVENTS = Object.freeze({
  LOGIN_STARTED: 'login_started',
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  UPLOAD_SELECTED: 'upload_selected',
  UPLOAD_STARTED: 'upload_started',
  UPLOAD_TRANSFER_COMPLETED: 'upload_transfer_completed',
  UPLOAD_PROCESSING_COMPLETED: 'upload_processing_completed',
  UPLOAD_FAILED: 'upload_failed',
  VIDEO_PLAY_ATTEMPTED: 'video_play_attempted',
  VIDEO_PLAY_STARTED: 'video_play_started',
  VIDEO_PLAY_FAILED: 'video_play_failed',
  EVALUATION_SAVE_STARTED: 'evaluation_save_started',
  EVALUATION_SAVE_CONFIRMED: 'evaluation_save_confirmed',
  EVALUATION_SAVE_FAILED: 'evaluation_save_failed',
  MULTIPLE_CHOICE_SUBMISSION_STARTED: 'multiple_choice_submission_started',
  MULTIPLE_CHOICE_SUBMISSION_CONFIRMED: 'multiple_choice_submission_confirmed',
  MULTIPLE_CHOICE_SUBMISSION_FAILED: 'multiple_choice_submission_failed',
  SESSION_EXPIRED: 'session_expired',
  SESSION_EXTENSION_STARTED: 'session_extension_started',
  SESSION_RECOVERY_SUCCEEDED: 'session_recovery_succeeded',
  SESSION_RECOVERY_FAILED: 'session_recovery_failed',
  COURSE_NAVIGATION_SELECTED: 'course_navigation_selected',
  COURSE_NAVIGATION_LOADED: 'course_navigation_loaded',
  COURSE_NAVIGATION_FAILED: 'course_navigation_failed',
});

export const EVENT_DEFINITIONS = Object.freeze({
  [EVENTS.LOGIN_STARTED]: ['login', 'started', false],
  [EVENTS.LOGIN_SUCCEEDED]: ['login', 'succeeded', true],
  [EVENTS.LOGIN_FAILED]: ['login', 'failed', true],
  [EVENTS.UPLOAD_SELECTED]: ['upload', 'selected', false],
  [EVENTS.UPLOAD_STARTED]: ['upload', 'started', false],
  [EVENTS.UPLOAD_TRANSFER_COMPLETED]: ['upload', 'transfer_completed', false],
  [EVENTS.UPLOAD_PROCESSING_COMPLETED]: ['upload', 'processing_completed', true],
  [EVENTS.UPLOAD_FAILED]: ['upload', 'failed', true],
  [EVENTS.VIDEO_PLAY_ATTEMPTED]: ['video_play', 'attempted', false],
  [EVENTS.VIDEO_PLAY_STARTED]: ['video_play', 'started', true],
  [EVENTS.VIDEO_PLAY_FAILED]: ['video_play', 'failed', true],
  [EVENTS.EVALUATION_SAVE_STARTED]: ['evaluation_save', 'started', false],
  [EVENTS.EVALUATION_SAVE_CONFIRMED]: ['evaluation_save', 'confirmed', true],
  [EVENTS.EVALUATION_SAVE_FAILED]: ['evaluation_save', 'failed', true],
  [EVENTS.MULTIPLE_CHOICE_SUBMISSION_STARTED]: ['multiple_choice_submission', 'started', false],
  [EVENTS.MULTIPLE_CHOICE_SUBMISSION_CONFIRMED]: ['multiple_choice_submission', 'confirmed', true],
  [EVENTS.MULTIPLE_CHOICE_SUBMISSION_FAILED]: ['multiple_choice_submission', 'failed', true],
  [EVENTS.SESSION_EXPIRED]: ['session', 'expired', true],
  [EVENTS.SESSION_EXTENSION_STARTED]: ['session', 'extension_started', false],
  [EVENTS.SESSION_RECOVERY_SUCCEEDED]: ['session', 'recovery_succeeded', true],
  [EVENTS.SESSION_RECOVERY_FAILED]: ['session', 'recovery_failed', true],
  [EVENTS.COURSE_NAVIGATION_SELECTED]: ['course_navigation', 'selected', false],
  [EVENTS.COURSE_NAVIGATION_LOADED]: ['course_navigation', 'loaded', true],
  [EVENTS.COURSE_NAVIGATION_FAILED]: ['course_navigation', 'failed', true],
});

export const ALLOWED_EVENT_PROPERTIES = new Set([
  'auth_method',
  'failure_category',
  'failure_phase',
  'processing_mode',
  'save_mode',
  'video_provider',
]);
